import { render } from "./co-property-item.vue?vue&type=template&id=44c3ff86&scoped=true"
import script from "./js/co-property-item.js?vue&type=script&lang=js&external"
export * from "./js/co-property-item.js?vue&type=script&lang=js&external"

import "./co-property-item.vue?vue&type=style&index=0&id=44c3ff86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c3ff86"]])

export default __exports__